module.exports = __webpack_public_path__ + "img/news1-1.78e298f3.png";